import { useBlocNext } from "@blac/react";
import type { FC, ReactNode } from "react";
import { BottomSheet } from "../BottomSheet/BottomSheet";
import HashActionBloc from "./HashActionBloc";

interface HashBottomSheetProps {
  hash: string;
  children: ReactNode;
  trackingName?: string;
}

const HashBottomSheet: FC<HashBottomSheetProps> = ({
  hash,
  children,
  trackingName
}) => {
  const [{ activeHash }, { close }] = useBlocNext(HashActionBloc);

  const normalizedHash = hash.replace(/^#/, "").toLowerCase();
  const isOpen = activeHash?.toLowerCase() === normalizedHash;

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={close}
      trackingName={trackingName ?? `Hash Sheet: ${hash}`}
    >
      {children}
    </BottomSheet>
  );
};

export default HashBottomSheet;
